var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcButton',{directives:[{name:"shortkey",rawName:"v-shortkey",value:(['t']),expression:"['t']"}],staticClass:"button today",on:{"shortkey":_vm.today,"click":_vm.today}},[_vm._v("\n\t"+_vm._s(_vm.$t('calendar', 'Today'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }